import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import OrderChart from '../components/OrderChart';

const propTypes = {
  dispatch: PropTypes.func,
  auth: PropTypes.object,
  query: PropTypes.object.isRequired,
}

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      timeLineTop: 0,
    };
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.auth.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  render() {
    const styles = {
      dashBoardPage: {
        height: '50%',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
      }
    }

    return (
      <div style={styles.dashBoardPage}>
        <div className="container">
          <div className="row">
            <div className="col-md-auto justify-content-center">
              <OrderChart />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

DashboardPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    auth: state.auth,
    query: ownProps.location.query,
  };
}

export default connect(mapStateToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/containers/DashboardPage.js